import Reservations from './dispatch-reservations'
import Drivers from './dispatch-drivers'
import Map from './dispatch-map'
import Modal from './dispatch-modal'
import Schedule from './dispatch-schedule'

import Notification from './dispatch-notification'
import NotificationNewBooking from './notification-new-booking'
import AvailableDrivers from './available-drivers'
import UnavailableDrivers from './unavailable-drivers'
import QualifiedDrivers from './quilified-drivers'
import Lyft from './lyft'

let sharedMutations = []
sharedMutations = sharedMutations.concat(Reservations.sharedMutations)
sharedMutations = sharedMutations.concat(Drivers.sharedMutations)
sharedMutations = sharedMutations.concat(Map.sharedMutations)
sharedMutations = sharedMutations.concat(NotificationNewBooking.sharedMutations)

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    Reservations.state,
    Drivers.state,
    Schedule.state,
    Map.state,
    Modal.state,
    Notification.state,
    NotificationNewBooking.state,
    AvailableDrivers.state,
    UnavailableDrivers.state,
    QualifiedDrivers.state,
    Lyft.state,
  ),
  mutations: Object.assign(
    Reservations.mutations,
    Drivers.mutations,
    Schedule.mutations,
    Map.mutations,
    Modal.mutations,
    Notification.mutations,
    NotificationNewBooking.mutations,
    AvailableDrivers.mutations,
    UnavailableDrivers.mutations,
    QualifiedDrivers.mutations,
    Lyft.mutations,
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/dispatch/index.js